var Sp = Sp || {};

(function (app) {

    app.getCommonPasswords = function () {
        var args = Array.prototype.slice.call(arguments);

        var passlist = [
            "pureservice",
            "selfservice",
            "passord",
            "syscom",
            "support",
            "point"

        ];

        if (args) {
            args.forEach(function (item) {
                if (item && item.trim())
                    passlist.push(item);
            });
        }

        return passlist;
    };
}(Sp));